"use strict";
// Combines proposed changes into an object to overlay the careplan section data
var Model = require("../types/Model.js");
var par = require("par");

module.exports = Model({
	name: "managedcareplanchangedfields",
	init: init,
	listeners: listeners,
});

function init() {
	this.push({});
}

function listeners() {
	return {
		"managedcareplanproposedchanges:updated": process_proposed,
	};
}

function process_proposed(proposed) {
	var map = proposed
		.filter(isProposed)
		.reduce(addProposed, {});

	this.push(map);
}

function addProposed(map, proposed) {
	return proposed.changes
		.reduce(par(addChange, proposed), map);
}

function isProposed(proposal) {
	return proposal.state === "proposed";
}

function addChange(proposal, map, change) {
	var path = change.path;
	var value = change.value;
	var isAddObject = change.op === "add" && (typeof value === "object") && !Array.isArray(value) && path.indexOf("-") === -1;

	if(change.op === "remove"){
		path = path.split(0, path.lastIndexOf("/")) + "-";
	}

	var segments;
	if(isAddObject){
		var newPath = path.slice(1);
		var otherSegments = newPath.split("/");
		segments = getAddChanges(value, newPath);

		while(otherSegments.length){
			var segmentPath = otherSegments.join(".");
			segments.push(segmentPath);
			otherSegments.pop();
		}
	} else {
		segments = path.split("/").slice(1);
	}

	while(segments.length){
		var currentPath;
		if(isAddObject)
			currentPath = segments[segments.length - 1];
		else
			currentPath = segments.join(".");
		var currentItems = map[currentPath];
		if(!currentItems){
			currentItems = [];
			map[currentPath] = currentItems;
		}
		if(currentItems.indexOf(proposal) === -1)
			currentItems.push(proposal);
		segments.pop();
	}

	return map;
}

function getAddChanges(value, path){
	return Object.keys(value).reduce(function(changes, key){
		var properPath = path.replace(/\//g, ".");
		var newPath = properPath + "." + key;
		if(typeof(value[key]) === "object" && !Array.isArray(value[key])){
			return changes.concat(getAddChanges(value[key], newPath));
		} else {
			return changes.concat([newPath]);
		}
	}, []);
}
